import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

Alpine.data('logoslider', () => ({
    init() {
        const splide = new Splide(this.$root, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: false,
            pagination: false,
            mediaQuery: 'min',
            perMove: 1,
            inView: 'autoScroll',
            autoScroll: {
                speed: 0.75,
                autoStart: true,
                pauseOnHover: true,
            },
            breakpoints: {
                0: {
                    perPage: 2,
                },
                320: {
                    perPage: 3,
                },
                575: {
                    perPage: 4,
                },
                768: {
                    perPage: 5,
                },
                1024: {
                    perPage: 6,
                },
            },
        });

        splide.mount({ AutoScroll });
    },
}));
